import React, { FC, useEffect, useState } from 'react';

import useSendbirdStateContext from '@sendbird/uikit-react/useSendbirdStateContext';
import { GroupChannel } from '@sendbird/chat/groupChannel';
import { Box } from '@mui/material';

import {
  channelsMetadata,
  getTypeOfUser,
  TypeOfUser,
} from '@pharmaplan/common';
import AvatarPlaceholder from '@pharmaplan/common/assets/icons/avatarPlaceholder.png';

import { useAppSelector } from '../../../../hooks/useAppSelector';
import strings from '../../../../localization';

import styles from './styles';

interface IChatAvatar {
  url: string;
}

const ChatAvatar: FC<IChatAvatar> = ({ url }) => {
  const channelData = useAppSelector(channelsMetadata);
  const context = useSendbirdStateContext();
  const { sdk } = context?.stores?.sdkStore ?? {};

  const [channel, setChannel] = useState<GroupChannel | never[]>([]);

  const userType = useAppSelector(getTypeOfUser);
  const isPharmacy = userType === TypeOfUser.pharmacy;

  const { userId } = channelData?.[url] ?? {};

  const [pharmacyId, pharmacistId] = userId?.split?.(',') ?? [];
  const id = isPharmacy ? pharmacistId : pharmacyId;

  const { plainProfileUrl } = (channel as GroupChannel)?.members?.find?.((item) =>
    item.userId === id)
    ?? {};

  useEffect(() => {
    if (sdk) {
      sdk?.groupChannel?.getChannel(url).then((res) => {
        setChannel(res);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sdk]);

  return (
    <Box
      component="img"
      src={plainProfileUrl || AvatarPlaceholder}
      alt={strings.picture}
      sx={[styles.avatar, isPharmacy && styles.fit]}
    />
  );
};

export default ChatAvatar;
